import { gql } from "@apollo/client";
import { PostTemplateForEditorFragment } from "generated/schemaTypes";

export const POST_TEMPLATE_FOR_EDITOR_FRAGMENT = gql`
  fragment PostTemplateForEditorFragment on PostTemplate {
    id
    name
    title
    data
  }
`;

type PostTemplate = PostTemplateForEditorFragment;

export default PostTemplate;
